let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4rWe1")).then(() => parcelRequire('fT41A'));